import React, { useEffect, useState } from "react";
import PersonalInfoForm from "../components/PersonalInfoform";
import BusinessInfoForm from "../components/BusinessInfoform";
import Verification from "../components/Verification";
import { SignUp, getUniqueUsernameSrNo } from "../services/btc-api.service";

function Signup() {
  const [step, setStep] = useState(1);
  const [personalInfoData, setPersonalInfoData] = useState({
    userId: "",
    firstName: "",
    lastName: "",
    city: "",
    country: "",
    zipCode: "",
    streetAddress: "",
    email: "",
    selectedCountryCode: "",
    contactNumber: "",
    alternateCountryCode: "",
    alternateContactNumber: "",
    state: "",
    selectedImage: "",
    alternateselectedImage: "",
    gender: "",
    selectedDateOfBirth: null,
  });

  const [businessInfoFormData, setBusinessInfoFormData] = useState({
    selectedOptions: [],
    businessName: "",
    destinationCountry: "",
    tradeTerm: "",
    destinationPort: "",
    selectedBusinessImage: null,
    shippingMethod: "",
    password: "",
    confirmPassword: "",
    passwordMatchError: false,
    agreedTerms: "",
    receivedpromotion: "",
  });

  const RegisterUser = async () => {
    await SignUp({
      email: personalInfoData.email,
      password: businessInfoFormData.password,
      contactNumber: personalInfoData.contactNumber,
      secondaryContactNumber: personalInfoData.alternateContactNumber,
      gender: personalInfoData.gender,
      firstName: personalInfoData.firstName,
      lastName: personalInfoData.lastName,
      dob: personalInfoData.selectedDateOfBirth,
      idCardFirst: personalInfoData.selectedImage,
      idCardTwo: personalInfoData.alternateselectedImage,
      streetAddress: personalInfoData.streetAddress,
      zipCode: personalInfoData.zipCode,
      city: personalInfoData.city,
      state: personalInfoData.state,
      country: personalInfoData.country,
      businessName: businessInfoFormData.businessName,
      businessTypes: businessInfoFormData.businessName,
      businessCard: businessInfoFormData.selectedBusinessImage,
      tradeTerm: businessInfoFormData.tradeTerm,
      shippingMethod: businessInfoFormData.shippingMethod,
      port: businessInfoFormData.destinationPort,
      shippingCountry: businessInfoFormData.destinationCountry,
      usernameSrNo: personalInfoData.userId,
      agreedTerms: businessInfoFormData.agreedTerms,
      receivedpromotion: businessInfoFormData.receivedpromotion,
    });
  };

  // useEffect(() => {
  //   getUniqueSrNo();
  // })
  const getUniqueSrNo = async () => {
    const uniqueSr = await getUniqueUsernameSrNo();
    setPersonalInfoData({
      ...personalInfoData,
      userId: uniqueSr ? uniqueSr.userId : 0,
    });
  };

  const handleDateOfBirthChange = (date) => {
    setPersonalInfoData({
      ...personalInfoData,
      selectedDateOfBirth: date,
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setPersonalInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleVerificationInputChange = (event) => {
    const { name, value } = event.target;

    setPersonalInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBusinessInputChange = (event) => {
    const { name, value } = event.target;

    setBusinessInfoFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBusinessInputCheckbox = (event) => {
    const { name, value } = event.target;

    setBusinessInfoFormData((prevData) => ({
      ...prevData,
      agreedTerms: value,
    }));
  };

  const handleOptionSelect = (selectedValue) => {
    if (selectedValue) {
      setBusinessInfoFormData((prevBusinessInfo) => ({
        ...prevBusinessInfo,
        selectedOptions: [...prevBusinessInfo.selectedOptions, selectedValue],
      }));
    }
  };

  const handleRemoveOption = (indexToRemove) => {
    const newArr = businessInfoFormData.selectedOptions.filter(
      (_, index) => index !== indexToRemove
    );

    setBusinessInfoFormData({
      ...businessInfoFormData,
      selectedOptions: [...newArr],
    });
  };

  const handlePersonalInfoNext = () => {
    setStep(2);
  };

  const handleBusinessInfoBack = () => {
    setStep(1);
  };
  const handleBusinessInfoNext = () => {
    setStep(3);
  };

  const handleVerificationBack = () => {
    setStep(2);
  };

  const handleVerificationSubmit = () => {
    alert("Form submitted successfully!");
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("file", file);

    fetch(process.env.REACT_APP_BTC_API_URL + "/", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setPersonalInfoData({
          ...personalInfoData,
          selectedImage: `${process.env.REACT_APP_BTC_API_URL}/${data.data.flag}`,
        });
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };

  const handleBusinessImageChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("file", file);

    fetch(process.env.REACT_APP_BTC_API_URL + "/", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setBusinessInfoFormData({
          ...businessInfoFormData,
          selectedBusinessImage: `${process.env.REACT_APP_BTC_API_URL}/${data.data.flag}`,
        });
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };

  const handleAlternateImageChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("file", file);

    fetch(process.env.REACT_APP_BTC_API_URL + "/", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setPersonalInfoData({
          ...personalInfoData,
          alternateselectedImage: `${process.env.REACT_APP_BTC_API_URL}/${data.data.flag}`,
        });
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };

  return (
    <div className="Personalinfo-page">
      <form>
        <div className="container">
          <img
            src="register with btc (2).png"
            alt="Logo"
            className="Btclogostyle"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "80%",
                background: step === 1 ? "#21429D" : "white",
                // margin: '0 0px',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: step === 1 ? "white" : "#21429D",
                fontWeight: "bold",
                border: "1px solid #21429D",
              }}
            >
              1
            </div>
            <div
              style={{
                width: "80px",
                height: "1px",
                background: "#21429D",
              }}
            ></div>
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                background:
                  step === 2 ? "#21429D" : step >= 2 ? "white" : "white",
                // margin: '0 1px',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: step === 2 ? "white" : "#21429D",
                fontWeight: "bold",
                border: "1px solid #21429D",
              }}
            >
              2
            </div>
            <div
              style={{
                width: "80px",
                height: "1px",
                background: "#21429D",
              }}
            ></div>
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                background: step === 3 ? "#21429D" : "white",
                // margin: '0 1px',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: step === 3 ? "white" : "#21429D",
                fontWeight: "bold",
                border: "1px solid #21429D",
              }}
            >
              3
            </div>
          </div>
          {step === 1 && (
            <PersonalInfoForm
              handleDateOfBirthChange={handleDateOfBirthChange}
              handleAlternateImageChange={handleAlternateImageChange}
              handleImageChange={handleImageChange}
              personalInfoData={personalInfoData}
              setPersonalInfoData={setPersonalInfoData}
              handleInputChange={(e) => handleInputChange(e)}
              onNext={handlePersonalInfoNext}
              getUniqueSrNo={getUniqueSrNo}
            />
          )}
          {step === 2 && (
            <BusinessInfoForm
              handleBusinessInputCheckbox={handleBusinessInputCheckbox}
              handleBusinessImageChange={handleBusinessImageChange}
              handleRemoveOption={handleRemoveOption}
              handleOptionSelect={handleOptionSelect}
              handleBusinessInputChange={handleBusinessInputChange}
              businessInfoFormData={businessInfoFormData}
              setBusinessInfoFormData={setBusinessInfoFormData}
              onBack={handleBusinessInfoBack}
              onNext={handleBusinessInfoNext}
            />
          )}
          {step === 3 && (
            <Verification
              handleVerificationInputChange={handleVerificationInputChange}
              personalInfoData={personalInfoData}
              RegisterUser={RegisterUser}
              onBack={handleVerificationBack}
              onNext={handleVerificationSubmit}
            />
          )}
        </div>
      </form>
    </div>
  );
}

export default Signup;
